"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SideNav = void 0;
/** @prettier */
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_responsive_1 = __importDefault(require("react-responsive"));
var R = __importStar(require("ramda"));
var Icons_1 = require("./Icons");
var SideNav = /** @class */ (function (_super) {
    __extends(SideNav, _super);
    function SideNav() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SideNav.prototype.render = function () {
        var _this = this;
        return (react_1["default"].createElement(react_responsive_1["default"], { maxWidth: 1224 }, function (matches) { return (react_1["default"].createElement(SideNavP, __assign({ matches: matches }, _this.props), _this.props.children)); }));
    };
    return SideNav;
}(react_1["default"].Component));
exports.SideNav = SideNav;
var SideNavP = /** @class */ (function (_super) {
    __extends(SideNavP, _super);
    function SideNavP(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            sideNavPreviousState: _this.props.initializedCollapsed || _this.props.matches
        };
        return _this;
    }
    SideNavP.prototype.componentWillMount = function () {
        this.props.onClick(this.props.initializedCollapsed || this.props.matches);
    };
    SideNavP.prototype.componentWillReceiveProps = function (nextProps) {
        var resizePage = R.not(R.equals(this.props.matches, nextProps.matches));
        if (resizePage) {
            this.setState({
                sideNavPreviousState: nextProps.collapsed
            });
            var resizeVar = !nextProps.matches && this.state.sideNavPreviousState
                ? nextProps.collapsed
                : nextProps.matches;
            this.props.onClick(resizeVar);
        }
    };
    SideNavP.prototype.render = function () {
        var _a = this.props, appName = _a.appName, onClick = _a.onClick, collapsed = _a.collapsed, children = _a.children, userMenu = _a.userMenu, homeLink = _a.homeLink, restProps = __rest(_a, ["appName", "onClick", "collapsed", "children", "userMenu", "homeLink"]);
        var restPropsForDOMElements = R.omit(['initializedCollapsed', 'logoBackground', 'toggleSideNav', 'matches'], restProps);
        var toggle = function () { return onClick(!collapsed); };
        var capAppName = appName ? appName.toUpperCase() : '';
        var userMenuWithColor = userMenu
            ? react_1["default"].cloneElement(userMenu, { color: '#49c5b1' })
            : null;
        return (react_1["default"].createElement("ul", __assign({}, restPropsForDOMElements, { className: 'vs-sidenav' + (collapsed ? ' collapsed' : ' active') }),
            react_1["default"].createElement("li", { className: "vs-sideNav-left-logo" },
                react_1["default"].createElement("a", { href: "".concat(homeLink ? homeLink : '/'), className: "vs-sidenav-container-row" },
                    react_1["default"].createElement("div", { className: "vs-logo" }, this.props.logo),
                    react_1["default"].createElement("span", { className: "vs-app-name" }, capAppName))),
            children,
            userMenuWithColor,
            react_1["default"].createElement("li", { className: "vs-toggle-icon" },
                react_1["default"].createElement(Icons_1.ToggleIcon, { onClick: toggle, sideNavState: collapsed }))));
    };
    return SideNavP;
}(react_1["default"].Component));
SideNav.propTypes = {
    active: prop_types_1["default"].bool
};
